import React, { useState } from 'react'
import { Button, Box, Typography } from '@material-ui/core'
import MediaSelector from '../MediaSelector'
import { MediaItem } from '../../../helpers/media-helper'

interface MediaUploadSelectorProps {
  onFileSelect: (file: { 
    path: string | string[]; 
    name: string;
    ids?: string | string[];
  }) => void
  mediaType: 'thumb' | 'inDesign' | 'download'
  currentMedia: string[]
  variantIndex: number
  keycloak?: unknown
}

const MediaUploadSelector: React.FC<MediaUploadSelectorProps> = ({
  onFileSelect,
  mediaType,
  currentMedia,
  variantIndex,
  keycloak, 
}) => {
  const [showMediaSelector, setShowMediaSelector] = useState(false)

  const handleExistingMediaSelect = (selectedItems: MediaItem[]) => {
    // For media arrays (thumbnails), we need to handle multiple selections differently
    if (mediaType === 'thumb') {
      // Create a single call with all selected items
      const allPaths = selectedItems.map(item => item.path)
      const allIds = selectedItems.map(item => item._id)
      onFileSelect({
        path: allPaths, // Pass array of paths
        name: selectedItems.map(item => item.name).join(', '), // Combined names
        ids: allIds, // Pass array of IDs
      })
    } else {
      // For single file types (inDesign, download), only use the first selected item
      if (selectedItems.length > 0) {
        onFileSelect({
          path: selectedItems[0].path,
          name: selectedItems[0].name,
          ids: selectedItems[0]._id, // Pass single ID
        })
      }
    }
    setShowMediaSelector(false)
  }

  const getTitle = () => {
    switch (mediaType) {
      case 'thumb':
        return 'Select From Existing Images'
      case 'inDesign':
        return 'Select From Existing InDesign Files'
      case 'download':
        return 'Select From Existing Download Files'
      default:
        return 'Select From Existing Media'
    }
  }

  return (
    <Box>
      <Button
        variant="outlined"
        color="primary"
        onClick={() => setShowMediaSelector(true)}
        fullWidth
      >
        {getTitle()}
      </Button>

      <MediaSelector
        open={showMediaSelector}
        onClose={() => setShowMediaSelector(false)}
        onSelect={handleExistingMediaSelect}
        mediaType={mediaType}
        currentMedia={currentMedia}
        multiple={mediaType === 'thumb'} // Allow multiple selection only for thumbnails
        keycloak={keycloak}
        hideActions={true}
      />
    </Box>
  )
}

export default MediaUploadSelector
